import React from 'react';
export default function HeartTrailSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="pet-svg">
      <style>{`
        @keyframes ht-float1 {
          0% { transform: translate(0, 0) scale(1); opacity: 0.9; }
          50% { transform: translate(-3px, -14px) scale(0.85); opacity: 0.7; }
          100% { transform: translate(2px, -28px) scale(0.5); opacity: 0; }
        }
        @keyframes ht-float2 {
          0% { transform: translate(0, 0) scale(1); opacity: 0.85; }
          50% { transform: translate(4px, -12px) scale(0.9); opacity: 0.6; }
          100% { transform: translate(-2px, -26px) scale(0.4); opacity: 0; }
        }
        @keyframes ht-float3 {
          0% { transform: translate(0, 0) scale(1); opacity: 0.8; }
          50% { transform: translate(-2px, -16px) scale(0.8); opacity: 0.55; }
          100% { transform: translate(3px, -30px) scale(0.35); opacity: 0; }
        }
        @keyframes ht-float4 {
          0% { transform: translate(0, 0) scale(1); opacity: 0.75; }
          50% { transform: translate(3px, -10px) scale(0.9); opacity: 0.5; }
          100% { transform: translate(-1px, -24px) scale(0.45); opacity: 0; }
        }
        .ht-h1 { animation: ht-float1 2.4s ease-out infinite; }
        .ht-h2 { animation: ht-float2 2.8s ease-out infinite 0.5s; }
        .ht-h3 { animation: ht-float3 3.2s ease-out infinite 1.0s; }
        .ht-h4 { animation: ht-float4 2.6s ease-out infinite 1.5s; }
        .ht-h5 { animation: ht-float1 3.0s ease-out infinite 2.0s; }
      `}</style>
      <defs>
        <linearGradient id="htGrad1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF6B9D" />
          <stop offset="100%" stopColor="#E91E63" />
        </linearGradient>
        <linearGradient id="htGrad2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF8A80" />
          <stop offset="100%" stopColor="#FF5252" />
        </linearGradient>
        <linearGradient id="htGrad3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F48FB1" />
          <stop offset="100%" stopColor="#E91E63" />
        </linearGradient>
      </defs>

      {/* Heart 1 - center, medium */}
      <g className="ht-h1" style={{ transformOrigin: '20px 34px' }}>
        <path d="M20 36C20 36 14 30 14 27C14 25 16 24 18 24C19 24 20 25 20 25C20 25 21 24 22 24C24 24 26 25 26 27C26 30 20 36 20 36Z"
          fill="url(#htGrad1)" />
        <path d="M17 26C17 26 16.5 25.5 17.5 25C18.5 24.5 19 25.5 19 25.5"
          fill="white" opacity="0.4" />
      </g>

      {/* Heart 2 - left, small */}
      <g className="ht-h2" style={{ transformOrigin: '11px 35px' }}>
        <path d="M11 37C11 37 8 34 8 32.5C8 31.5 9 31 10 31C10.5 31 11 31.5 11 31.5C11 31.5 11.5 31 12 31C13 31 14 31.5 14 32.5C14 34 11 37 11 37Z"
          fill="url(#htGrad2)" />
      </g>

      {/* Heart 3 - right, small */}
      <g className="ht-h3" style={{ transformOrigin: '30px 33px' }}>
        <path d="M30 35C30 35 27.5 32.5 27.5 31.2C27.5 30.4 28.3 30 29 30C29.4 30 30 30.4 30 30.4C30 30.4 30.6 30 31 30C31.7 30 32.5 30.4 32.5 31.2C32.5 32.5 30 35 30 35Z"
          fill="url(#htGrad3)" />
      </g>

      {/* Heart 4 - center-left, tiny */}
      <g className="ht-h4" style={{ transformOrigin: '16px 37px' }}>
        <path d="M16 38.5C16 38.5 14.5 37 14.5 36.3C14.5 35.8 15 35.5 15.5 35.5C15.7 35.5 16 35.8 16 35.8C16 35.8 16.3 35.5 16.5 35.5C17 35.5 17.5 35.8 17.5 36.3C17.5 37 16 38.5 16 38.5Z"
          fill="#FF8A80" />
      </g>

      {/* Heart 5 - center-right, tiny */}
      <g className="ht-h5" style={{ transformOrigin: '25px 36px' }}>
        <path d="M25 37.5C25 37.5 23.5 36 23.5 35.3C23.5 34.8 24 34.5 24.5 34.5C24.7 34.5 25 34.8 25 34.8C25 34.8 25.3 34.5 25.5 34.5C26 34.5 26.5 34.8 26.5 35.3C26.5 36 25 37.5 25 37.5Z"
          fill="#F48FB1" />
      </g>
    </svg>
  );
}
